import { ref, onMounted, getCurrentInstance } from "vue";
function useGetFirstElement() {
  const firstElement = ref(null);
  onMounted(() => {
    var _a, _b, _c;
    firstElement.value = (_c = (_b = (_a = getCurrentInstance()) == null ? void 0 : _a.proxy) == null ? void 0 : _b.$el) == null ? void 0 : _c.nextElementSibling;
  });
  return firstElement;
}
export {
  useGetFirstElement as default
};
//# sourceMappingURL=useGetFirstElement.mjs.map
